import React, {useEffect, useState} from 'react';
import {
    fetchInstructions,
    openDeleteModalInst,
    openModalTriggerUpdate,
    updateItemInstruction
} from "../../redux-store/triggers";
import {useDispatch, useSelector} from "react-redux";
import {Pagination, Select} from "antd";
import {
    deleteItemInstConfirmation,
    getAllInstructions,
    getAllInstructionsPaggination
} from "../../redux-store/selectors";
import api from "../../api/apiInterceptor";
import ConfirmationDeleteInstruction from "./ConfirmationDeleteInstruction";
import editIcon from "../../images/Group 28.svg";
import trashIcon from "../../images/bin.svg";
import NoDataComponent from "../NoDataComponent";

const {Option} = Select

const TriggerList = ({installationId, triggerItemId, eventKey, allDevices, allLocations}) => {

    const dispatch = useDispatch()
    const instructionsItem = useSelector(getAllInstructions)
    const {totalInst, pageSizeInst, currentPageInst} = useSelector(getAllInstructionsPaggination);
    const deleteDialog = useSelector(deleteItemInstConfirmation)

    const [commandProducersOptions, setCommandProducersOptions] = useState([])
    const [instructionOption, setInstructionOption] = useState([]);

    useEffect(() => {
        if (triggerItemId !== eventKey) return;

    }, []);


    useEffect(() => {
        if (triggerItemId === eventKey) {
            dispatch(fetchInstructions({installationId, triggerItemId}));
            assembleSelects();
            deviceAndLocationSelectOption();
        }
    }, [installationId, triggerItemId, eventKey]);


    const assembleSelects = async () => {
        let results = await api.get("/api/devicetypes")

        const commandProducers = []
        results.data.map((device) => {
            commandProducers.push(...device.commandProducers)
        })

        const uniqCommandProducers = [...new Set(commandProducers)];

        setCommandProducersOptions(uniqCommandProducers?.map((item, index) => {
            return (<Option key={index} value={item}>{item}</Option>)
        }))
    }

    const deviceAndLocationSelectOption = () => {
        const optionSelect = allDevices.map(itm => ({
            ...allLocations.find((item) => (item.id === itm.locationId) && item),
            ...itm
        }));

        setInstructionOption(optionSelect.map((item, key) => {
            return (<Option key={item.id}
                            value={item.id}>{`${item.model}#${item.id} @${item.name ? item.name : ""}`}</Option>)
        }))
    }

    const handleUpdateItem = (data) => {
        dispatch(openModalTriggerUpdate(data.id))
        dispatch(updateItemInstruction(data))
    }

    const handleOpenConfirmationModal = (id) => {
        dispatch(openDeleteModalInst(id))
    }

    const handleShowModalForCreate = () => {
        dispatch(openModalTriggerUpdate(triggerItemId))
    }

    const generateLines = () => {
        return instructionsItem.map((item, key) => {
            return (
                <div className={"row pt-3"} key={key}>
                    <div className="col-12 col-md-4 col-lg-4 col-xl-4 pb-2 ant-select-trigger">
                        <Select
                            placeholder={"Device"}
                            className={"form-select"}
                            showSearch
                            getPopupContainer={node => node.parentNode}
                            defaultValue={item.deviceId}
                            disabled
                        >
                            {instructionOption}
                        </Select>
                    </div>

                    <div className="col-12 col-md-4 col-lg-4 col-xl-4 pb-2 ant-select-trigger">
                        <Select
                            placeholder={"Method Name"}
                            className={"form-select"}
                            showSearch
                            getPopupContainer={node => node.parentNode}
                            defaultValue={item.methodName}
                            disabled
                        >
                            {commandProducersOptions}
                        </Select>
                    </div>

                    <div className="col-12 col-md-2 col-lg-2 col-xl-2 pb-2">
                        <input className="form-control" type="text" disabled  defaultValue={JSON.stringify(item.arguments).slice(1,-1)}/>
                    </div>

                    <div className="col-12 col-md-1 col-lg-1 col-xl-1 pb-1 text-right cursor-button">
                        <img onClick={() => handleUpdateItem(item)} src={editIcon} alt={"Edit Icon"}
                        />
                    </div>
                    <div className="col-12 col-md-1 col-lg-1 col-xl-1 pb-1 btn-trash-bin cursor-button">
                        <img onClick={() => handleOpenConfirmationModal(item.id)} src={trashIcon} alt={"Trash Icon"}
                        />
                    </div>
                </div>
            )
        })
    }

    return (
        <>
            <div className={"container"}>
                <div className={"row pb-4 device-details-selected-device device-body-header-triggers"}>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                        <h4 className="card-label mb-unset">Instrukcije </h4>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-6 text-right">
                        <button className={"btn btn-location"} onClick={handleShowModalForCreate}>Dodaj instrukciju
                        </button>
                    </div>
                </div>
                {instructionsItem.length > 0 ? generateLines() : <NoDataComponent dataName={"instrukcija"}/>}
                <div className={"row text-right pt-2"}>
                    <Pagination defaultCurrent={1}
                                current={currentPageInst + 1}
                                total={totalInst}
                                showSizeChanger={false}
                                onChange={(newPage) => {
                                    dispatch(fetchInstructions({
                                        installationId,
                                        triggerItemId,
                                        page: newPage - 1,
                                        pageSizeInst
                                    }));
                                }}/>
                </div>
                {deleteDialog &&
                <ConfirmationDeleteInstruction installationId={installationId} eventKey={eventKey}/>}
            </div>
        </>
    );
};

export default TriggerList;
